import { Organization } from '@airship-platform/airship-patterns';
import {
  calculateOptionCosts,
  mapLinkedItems,
  resolveMembershipSavings,
} from '@airship-platform/proposal-financing-feature/utils';
import { AppointmentProposalOptionModifier } from '../../../data-access/appointmentProposalOptionModifiers';
import { AppointmentProposalOptionProduct } from '../../../data-access/appointmentProposalOptionProducts';

export const buildOptionCosts = (
  optionProducts: AppointmentProposalOptionProduct[],
  optionModifiers: AppointmentProposalOptionModifier[],
  options: Parameters<typeof calculateOptionCosts>[0]['config'] &
    Organization['costSettings']
) => {
  const nonLinkedProducts = optionProducts.filter(
    (p) => p.groupingName !== 'LINKED_ITEM'
  );

  const buildRequest = (useMembershipPrice: boolean) => ({
    products: mapLinkedItems(nonLinkedProducts, {
      linkedItemsChargeable: options.linkedItemsChargeable,
      useMembershipPrice,
    }),
    discounts: optionModifiers.filter((m) => m.modifierType === 'DISCOUNT'),
    fees: optionModifiers.filter((m) => m.modifierType === 'FEE'),
    rebates: optionModifiers.filter((m) => m.modifierType === 'REBATE'),
    config: { taxRate: options.taxRate },
  });

  const memberCosts = calculateOptionCosts(
    buildRequest(options.membershipPricingEnabled)
  );

  const {
    adjustmentsTotal,
    discountsTotal,
    rebatesTotal,
    feesTotal,
    feesTotalTaxable,
    feesTotalTax,
    ...rest
  } = memberCosts;

  return {
    ...resolveMembershipSavings(
      memberCosts,
      options.membershipPricingEnabled
        ? calculateOptionCosts(buildRequest(false))
        : undefined
    ),
    adjustments: adjustmentsTotal,
    discounts: discountsTotal,
    rebates: rebatesTotal,
    fees: feesTotal,
    feesTax: feesTotalTax,
    feesTaxable: feesTotalTaxable,
    ...rest,
  };
};
